// extracted by mini-css-extract-plugin
export default {"modal_content":"EnterPromo_modal_content__pLMw1","modal_header":"EnterPromo_modal_header__fC2rV","input":"EnterPromo_input__Z9oBc","btn":"EnterPromo_btn__DtP2e"};